export const CLICKSDATA = {
  labels: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  datasets: [
    {
      label: "Clicks",
      data: [300, 400, 450, 490, 500, 600, 610, 590, 750, 820, 890, 960],
      fill: "start",
      backgroundColor: "#F1F3FF",
      borderColor: "#2D55FB",
      tension: 0,
    },
  ],
};

export const VIEWSDATA = {
  labels: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  datasets: [
    {
      label: "Views",
      data: [300, 400, 450, 490, 400, 300, 210, 290, 350, 320, 490, 560],
      backgroundColor: "#F1F3FF",
      borderColor: "#2D55FB",
      tension: 0,
    },
  ],
};

export const ADSPENDDATA = {
  labels: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  datasets: [
    {
      label: "Ad spend",
      data: [300, 300, 550, 390, 400, 600, 410, 590, 750, 620, 590, 660],
      backgroundColor: "#F1F3FF",
      borderColor: "#2D55FB",
      tension: 0,
    },
  ],
};
